/** Synthetic emails used only to satisfy the User model for school-login students. */
export function isInternalSchoolEmail(email) {
  const normalized = String(email || "")
    .trim()
    .toLowerCase();
  return !normalized || normalized.endsWith("@school.ots");
}

/** Email shown on My Account / profile surfaces. Hides internal placeholders. */
export function getDisplayEmail(email) {
  if (isInternalSchoolEmail(email)) return "";
  return String(email || "").trim();
}
